import React from 'react';
import i18n from '@/utils/i18n';
import { Currency } from '@/utils/price';
import { Button } from '@/components/ui/button';

interface EventInvoiceInfoTabProps {
  loading: boolean;
  saveEvent: () => void;
  entity: string;
  currency: string;
  setCurrency: (currency: string) => void;
  external_zoho_id?: string | null;
}

const EventInvoiceInfoTab: React.FC<EventInvoiceInfoTabProps> = ({
  loading,
  saveEvent,
  entity,
  currency,
  setCurrency,
  external_zoho_id,
}) => {
  if (external_zoho_id) {
    return (
      <div className="tw:space-y-6">
        <div className="tw:flex tw:justify-between tw:items-center">
          <h3 className="tw:text-xl tw:font-semibold">
            {i18n.t('Event:invoiceInfo')}
          </h3>
        </div>
        <div className="tw:space-y-2">
          <div className="tw:mb-2">
            <strong className="tw:mr-2">{i18n.t('Event:legalEntity')}:</strong>
            <span>{entity}</span>
          </div>
          <div className="tw:mb-2">
            <strong className="tw:mr-2">{i18n.t('Event:currency')}:</strong>
            <span>{i18n.t(`Common:currency${currency.toUpperCase()}`)}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tw:space-y-6">
      <div className="tw:flex tw:justify-between tw:items-center">
        <h3 className="tw:text-xl tw:font-semibold">
          {i18n.t('Event:invoiceInfo')}
        </h3>
        <Button onClick={saveEvent} disabled={loading}>
          {loading ? i18n.t('Common:loading') : i18n.t('Common:save')}
        </Button>
      </div>
      <div>
        <div className="tw:flex tw:mb-1">
          <span className="tw:inline-flex tw:items-center tw:px-3 tw:py-2 tw:border tw:border-r-0 tw:rounded-l-md tw:text-primary/70">
            {i18n.t('Event:legalEntity')}
          </span>
          <input
            type="text"
            className="tw:flex-1 tw:px-3 tw:py-2 tw:border tw:rounded-r-md tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-primary"
            disabled
            value={entity || ''}
          />
        </div>
        <div className="tw:flex tw:mb-1">
          <span className="tw:inline-flex tw:items-center tw:px-3 tw:py-2 tw:border tw:border-r-0 tw:rounded-l-md tw:text-primary/70">
            {i18n.t('Event:currency')}
          </span>
          <select
            className="tw:flex-1 tw:px-3 tw:py-2 tw:border tw:rounded-r-md tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-primary"
            value={currency || ''}
            onChange={(e) => setCurrency(e.target.value)}
          >
            {Object.keys(Currency).map((currency) => (
              <option key={currency} value={currency.toLowerCase()}>
                {i18n.t(`Common:currency${currency}`)}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default EventInvoiceInfoTab;
